export const appTag = {
  edition: 'edition',
  apiEdition: 'api-edition',
  antiForgeryToken: 'anti-forgery-token',
  moduleId: 'module-id',
  tabId: 'tab-id',
  contentBlockId: 'content-block-id',

  // new in 11.01
  angularPath: 'angular-path',
}
